import React from "react"
import { shopFooterStyle } from "./styles"

const ShopFooter: React.FC = () => (
	<div css={shopFooterStyle}>
		<nav>
			<h2>Shop</h2>
			<ul>
				<li>
					<a href="/shop/search?categories=28&ordering=%2522title%2522">Parts</a>
				</li>
				<li>
					<a href="/shop/search?categories=%255B%252220%2522%252C%252215%2522%255D&ordering=%2522title%2522">
						Chemicals
					</a>
				</li>
			</ul>
		</nav>
	</div>
)

export default ShopFooter
